<script type="text/ecmascript-6">
    import Layout from '../layouts/Index.vue'
    import MainHeader from '../layouts/Header.vue'

    export default {
        name: 'TermsAndConditions',

        components: {
            Layout,
            MainHeader,
        },

        metaInfo() {
            return {
                title: 'Terms And Conditions',
            }
        },

        /**
         * The component's data.
         */
        data: () => ({
            body: '',
        }),


        /**
         * Created the component.
         */
        created() {
            this.fetchTermsAndConditions();
        },

        methods: {
            /**
             *  Get terms and conditions.
             */
            async fetchTermsAndConditions() {
                axios.get('/api/mmn/terms-and-conditions').then((response) => {
                    this.body = response.data;
                }).catch((error) => {

                });
            },
        }
    }
</script>

<template>
    <layout>

        <!---Main Content Start--->
        <div class="ms_content_wrapper ms_profile padder_top80">

            <main-header/>

            <div class="ms_radio_wrapper ms_purchase_wrapper">
                <div class="ms_heading">
                    <h1>Terms And Conditions</h1>
                </div>
                <div class="row">
                    <div class="container" v-html="body"></div>
                </div>
            </div>
        </div>


    </layout>
</template>
